import { render, staticRenderFns } from "./BlackGoldDepositPage.vue?vue&type=template&id=0c7aee05&"
import script from "./BlackGoldDepositPage.vue?vue&type=script&lang=js&"
export * from "./BlackGoldDepositPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports